var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/register/steps/RegisterMinorIntro.tsx";
import React, { useCallback } from 'react';
import { Text, VStack } from '@adc/parallax-component-library';
import { Footer, Header, LogoActionBar, Main, ScrollContainer } from 'Components/utility';
import i18n from 'Utilities/i18n';
const RegisterMinorIntro = ({
  next,
  back,
  values
}) => {
  const handleSubmit = useCallback(() => {
    next(values);
  }, [next, values]);
  const handleOnBack = useCallback(() => {
    back();
  }, [back]);
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(LogoActionBar, {
    actionButtonTestID: "CreateAccountIntro.action-go-back",
    titleTestID: "CreateAccountIntro.actionTitle",
    title: i18n.t('CreateAccountIntro.title'),
    onBack: handleOnBack,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(ScrollContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Header, {
    titleTestID: "CreateAccountIntro.title",
    title: i18n.t('CreateAccountIntro.title'),
    marginBottom: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(VStack, {
    paddingHorizontal: "$4",
    justifyContent: "center",
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: i18n.t('CreateAccountIntro.content.createAccountIntro.media.introMinor'),
    alt: "",
    width: "218px",
    height: "244px",
    id: "CreateAccountIntro.image-of-family",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(Text, {
    testID: "CreateAccountIntro.content.createAccountIntro.primaryText",
    color: "$text.100",
    fontWeight: "$bodyBase.medium",
    fontSize: "$bodyBase.medium",
    marginTop: "$5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 11
    }
  }, i18n.t('CreateAccountIntro.content.createAccountIntro.primaryText')), /*#__PURE__*/React.createElement(Text, {
    marginTop: "$4",
    testID: "CreateAccountIntro.content.createAccountIntro.bodyText",
    color: "$text.100",
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 11
    }
  }, i18n.t('CreateAccountIntro.content.createAccountIntro.bodyText', {
    appName: i18n.t('Global.appNames.libreView')
  })))), /*#__PURE__*/React.createElement(Footer, {
    buttonText: i18n.t('Global.microcopy.common.continue'),
    onButtonSubmit: handleSubmit,
    buttonTestID: "CreateAccountIntro.continue-btn",
    isButtonDisabled: false,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 7
    }
  }));
};
export default RegisterMinorIntro;